<template>
    <div class="compere-wrapper">
        <a-modal
            class="edit-compere"
            :visible="visible"
            title=""
            :width="600"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel">
            <a-form :form="form">
                <a-form-item style="display:none;">
                    <a-input v-decorator="['rules_id']"></a-input>
                </a-form-item>
                <a-form-item style="width:100%;" :label="$t('program.limit_period'/*限制时段*/)">
                    <a-radio-group v-decorator="['restriction_period', { rules: [{ required: true, message: $t('program.please_enter_limit_period'/*请输入限制时段*/ ) }] }]">
                        <a-radio value="1">{{$t('program.all'/*全部*/ )}}</a-radio>
                        <a-radio value="2">{{$t('program.every_day'/*每天*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="$t('program.limit_roles'/*限制角色*/)">
                    <a-radio-group v-decorator="['restriction_roles', { rules: [{ required: true, message: $t('program.please_choose_limit_roles'/*请选择限制角色*/ ) }] }]">
                        <a-radio value="1">{{$t('program.all'/*全部*/ )}}</a-radio>
                        <a-radio value="2">{{$t('program.host_type'/*主持类*/ )}}</a-radio>
                        <a-radio value="3">{{$t('program.discuss_type'/*讨论类*/ )}}</a-radio>
                        <a-radio value="4">{{$t('program.speaker_type'/*讲者类*/ )}}</a-radio>
                        <a-radio value="5">{{$t('program.host_and_discuss'/*主持和讨论类*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="$t('program.limit_edit_times'/*限制添加次数*/)">
                    <a-input-number style="width:100%;" v-decorator="['limit', { rules: [{ required: true, message: $t('program.please_enter_limit_times'/*请输入限制添加次数*/ ) }] }]"></a-input-number>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import pick from 'lodash.pick';
const fileds = ['rules_id', 'restriction_period', 'restriction_roles', 'limit'];
export default {
    name: 'editLimitModal',
    props: {
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        showFun(data) {
            this.visible = true
            if (data) {
                this.form.setFieldsValue(pick(data, fileds))
                this.form.setFieldsValue({
                    rules_id: data.id
                })
            }
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    this.$request.post({ url: 'addProgramLimit', data: values }).then(res => {
                        this.$message.success(res.message);
                        this.confirmLoading = false;
                        this.$emit('reset')
                        this.handleCancel();
                    }).finally(() => {
                        this.confirmLoading = false;
                    });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    },
    created () {
        fileds.forEach(v => this.form.getFieldDecorator(v))
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
</style>